import { useState } from "react";
import { AlertCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errorMessage } from "../../lib/api";
import { MSG_PASSWORD } from "./NewUserDialog";

export const ResetPasswordDialog = ({ user, onClose }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const close = () => {
    setPassword("");
    setError("");
    onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError(MSG_PASSWORD);
    setSaving(true);
    try {
      await api.post(`/users/${user.id}/reset-password`, { password });
      toast.success("Contraseña restablecida");
      close();
    } catch (err) {
      setError(errorMessage(err, "No se pudo restablecer la contraseña, intenta de nuevo"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!user} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="reset-password-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="text-lg font-extrabold text-[#182235]">Restablecer contraseña</DialogTitle>
          <DialogDescription className="text-xs text-[#5b667a]">Nueva contraseña para {user?.name} ({user?.email}).</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3.5">
          <label className="block">
            <span className="tr-label">Nueva contraseña (mínimo 8 caracteres)</span>
            <input required type="text" autoComplete="off" value={password} onChange={(e) => setPassword(e.target.value)} className="tr-input" data-testid="reset-password-input" />
          </label>
          {error && (
            <p role="alert" className="flex items-center gap-2 rounded-[10px] bg-[#fdf0ef] px-3 py-2 text-xs font-semibold text-[#b42318]" data-testid="reset-password-error">
              <AlertCircle className="h-4 w-4 shrink-0" /> {error}
            </p>
          )}
          <button type="submit" disabled={saving} className="tr-btn-primary h-11 w-full text-sm" data-testid="reset-password-submit">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Guardar contraseña"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
